<template>
  <BModal
    v-model="modal"
    title="Add Pending Action"
    ref="modalRef"
    ok-title="Save"
    ok-variant="success"
    @ok="handlePendingActionSubmission"
  >
    <div class="text-center">
      <BFormGroup
        id="input-group-date"
        label="Date:"
        label-for="date"
        class="floating-group"
      >
        <BFormInput
          id="date"
          v-model="date"
          type="date"
          size="sm"
          style="font-size: 0.85rem"
          :class="{ 'is-invalid': dateError !== null }"
        />
      </BFormGroup>
      <BFormGroup
        id="input-group-description"
        label="Description:"
        label-for="description-input"
        class="floating-group"
      >
        <BFormTextarea
          id="description-input"
          v-model="description"
          :class="{ 'is-invalid': descriptionError !== null }"
          placeholder="Enter something..."
          rows="3"
          style="font-size: 0.85rem"
        />
      </BFormGroup>
    </div>
  </BModal>
</template>
<script>
import {
  BModal,
  BFormGroup,
  BFormTextarea,
  BFormInput,
} from "bootstrap-vue-next";

export default {
  name: "CreatePendingActionModal",
  props: {
    acctUid: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      modal: false,
      date: null,
      dateError: null,
      description: null,
      descriptionError: null,
    };
  },
  components: {
    BModal,
    BFormGroup,
    BFormTextarea,
    BFormInput,
  },
  emits: ["pendingActionCreated"],
  mounted() {
    //Let's default the date to today's date and timezone; we will use the format YYYY-MM-DD which is the format for the date input field
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    this.date = `${year}-${month}-${day}`;
  },
  methods: {
    validateForm() {
      let isValid = true;

      if (!this.date) {
        this.dateError = "Date is required.";
        isValid = false;
      } else {
        this.dateError = null;
      }

      if (!this.description) {
        this.descriptionError = "Description is required.";
        isValid = false;
      } else {
        this.descriptionError = null;
      }

      return isValid;
    },
    async handlePendingActionSubmission(bvEvt) {
      try {
        bvEvt.preventDefault(); // Prevent the modal from closing immediately
        const formIsValid = this.validateForm();
        if (!formIsValid) return;

        if (!this.acctUid) {
          this.$notify.notifyError(
            "Account context is missing. Please select an account and try again."
          );
          return;
        }

        await this.$api.post(`/pending-actions`, {
          acct_uid: this.acctUid,
          pending_actions: [
            {
              created_date: this.date,
              content: this.description,
              fulfilled: "false",
            },
          ],
        });

        this.$refs.modalRef.hide();
        this.$notify.notifySuccess("Pending action saved successfully.");
        this.$emit("pendingActionCreated");
        this.resetModalState();
      } catch (error) {
        console.error("Error submitting pending action:", error);
        this.$notify.notifyError(
          "An error occurred while saving the pending action. Please try again."
        );
      }
    },
    resetModalState() {
      this.date = null;
      this.description = null;
      this.dateError = null;
      this.descriptionError = null;
    },
  },
};
</script>
